<template>
  <ProSpaceLeftPanel
    :panelName="$t('grouping')"
    :collapseDisabled="isGroupingOutletsMode"
    ref="leftPanel"
  >
    <template #center>
      <ProSpaceVLayout class="address-program__grouping-list" is-inline-h>
        <div
          class="prospace-checkbox"
          v-for="(group, index) of groupsModel"
          :key="index"
        >
          <Checkbox
            class="prospace-checkbox__input"
            v-model="selectedGroups"
            :inputId="index"
            name="group"
            :value="group.value"
          />
          <label class="prospace-checkbox__label" :for="index">{{
            $t(`${group.label}`)
          }}</label>
        </div>
      </ProSpaceVLayout>
    </template>
    <template #top-center>
      <ProSpaceAction
        @click="applyGroups"
        v-if="selectedGroups.length || isModelChanged"
      >
        {{ isModelChanged ? $t("applyTxt") : $t("resetTxt") }}
      </ProSpaceAction>
    </template>
  </ProSpaceLeftPanel>
</template>

<script>
import {
  ProSpaceLeftPanel,
  ProSpaceAction,
  ProSpaceVLayout,
} from "@prospace/prospace-components-library";
import Checkbox from "primevue/checkbox";

const _ = require("lodash");
export default {
  components: {
    ProSpaceLeftPanel,
    ProSpaceAction,
    ProSpaceVLayout,
    Checkbox,
  },
  props: {
    checkAccess: {
      type: Function,
    },
    service: {
      type: Object,
      default: null,
    },
    isGroupingOutletsMode: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Array,
      default: () => [],
    },
    isAttempedReset: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedGroups: [],
      selectedGroupsCopy: [],
    };
  },
  watch: {
    selected: {
      handler: function (arr) {
        if (arr?.length > 0) {
          this.selectedGroups = [
            ...new Set([this.selectedGroups, ...arr].flat()),
          ];
          this.cloneGroupModel();
        }
      },
      immediate: true,
    },
  },
  computed: {
    isModelChanged() {
      //sortBy для сравнивания групп не в строгом порядке
      return (
        !_.isEqual(
          _.sortBy(this.selectedGroups),
          _.sortBy(this.selectedGroupsCopy)
        ) || this.isAttempedReset
      );
    },
    groupsModel() {
      let groups = [];

      groups.push(
        {
          label: "rsm",
          value: "RSMId",
        },
        {
          label: "tdm",
          value: "TDMId",
        },
        {
          label: "kae",
          value: "KAEId",
        },
        {
          label: "outletType",
          value: "OutletTypeId",
        },
        {
          label: "externalFormat",
          value: "ExternalFormatId",
        },
        {
          label: "channel",
          value: "ChannelId",
        },
        {
          label: "narka",
          value: "NARKAId",
        },
        {
          label: "sipChannel",
          value: "SIPChannelId",
        },
        {
          label: "geoCluster",
          value: "ClusterId",
        }
      );

      if (this.checkAccess && this.checkAccess("agencyValue-leftPanel"))
        groups.push({
          label: "agency",
          value: "AgencyId",
        });

      groups.push(
        {
          label: "network",
          value: "NetworkId",
        },
        {
          label: "addressProgramOrderKasValue",
          value: "KASValue",
        }
      );

      return groups;
    },
  },
  mounted() {
    this.setSelectedGroup();
  },
  methods: {
    setSelectedGroup() {
      this.selectedGroups = this.service.getGroups();
      this.cloneGroupModel();
    },
    collapsePanel() {
      this.$refs.leftPanel.collapsed = !this.$refs.leftPanel.collapsed;
    },
    cloneGroupModel() {
      this.selectedGroupsCopy = _.cloneDeep(this.selectedGroups);
    },
    applyGroups: _.debounce(function () {
      if (this.isModelChanged) {
        this.$emit("selectGroups", this.selectedGroups);
        this.cloneGroupModel();
      } else {
        this.resetGroups();
      }
    }, 250),
    resetGroups() {
      this.selectedGroups = [];
      this.cloneGroupModel();
      this.$emit("selectGroups", this.selectedGroups);
    },
  },
};
</script>

<style lang="scss" scoped>
.address-program__grouping-list {
  padding-top: 10px;
  .prospace-checkbox {
    padding: 8px 15px;
  }
}
</style>
